/**
 * Smart Stable — مصدر رقم إصدار النظام (Single Source of Truth).
 *
 * 🔢 عند كل تحديث للبرنامج: زِد الرقم هنا فقط.
 *    الصيغة: MAJOR.MINOR.PATCH (مثال: 1.0.3)
 *      - MAJOR: تغييرات كبيرة/كاسرة
 *      - MINOR: ميزات جديدة
 *      - PATCH: إصلاحات وتحسينات صغيرة
 *
 * حدّث أيضًا APP_RELEASE_DATE بتاريخ الإصدار.
 * يظهر الرقم في الفوتر وأسفل القائمة الجانبية تلقائيًا.
 */

export const APP_VERSION = '3.4.84';

// تاريخ هذا الإصدار (YYYY-MM-DD)
export const APP_RELEASE_DATE = '2026-07-05';

// نص جاهز للعرض
export const APP_VERSION_LABEL = `v${APP_VERSION}`;

export default APP_VERSION;
